import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { staticTabData } from "./tabStaticData";

// ═══════════════════════════════════════════════════════════════
// Toggle this to false when backend is ready
// ═══════════════════════════════════════════════════════════════
const USE_STATIC_DATA = false;

/**
 * Helper function to get API base URL
 */
const getApiBaseUrl = () => {
  const appName = localStorage.getItem("appName");
  const network = localStorage.getItem("network");
  const collabType = localStorage.getItem("collabType");
  const roleName = localStorage.getItem("roleName");

  if (appName && network && collabType && roleName) {
    return `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
  }
  return null;
};

// ═══════════════════════════════════════════════════════════════
// STATIC DATA - matches Excel "Data Elements for Amgen (3).xlsx"
// ═══════════════════════════════════════════════════════════════

const STATIC_PLANNING = {
  status: true,
  planningData: {
    headerFields: [
      { label: "PO Due Date", value: "2026-01-21", timestamp: "2026-01-21T00:00:00" },
      { label: "Open CAPA Items", value: "No", timestamp: "2025-11-21T00:00:00" },
      { label: "Equipment Reservation", value: "Yes", timestamp: "2025-11-21T00:00:00" },
    ],
    milestones: [
      { item: "Raw Materials Order Placed In ERP", targetDate: "2025-11-20", expectedDate: "2025-11-20", actualDate: "2025-11-21", lastUpdate: "2025-11-21T00:00:00" },
      { item: "On-Time CMO Batch Record Issuance", targetDate: "2025-11-23", expectedDate: "2025-11-23", actualDate: "2025-11-23", lastUpdate: "2025-11-23T00:00:00" },
      { item: "CMO RM Release Date", targetDate: "2025-11-25", expectedDate: "2025-11-25", actualDate: "2025-11-26", lastUpdate: "2025-11-26T00:00:00" },
      { item: "CMO MFG Start Date", targetDate: "2026-01-19", expectedDate: "2026-01-19", actualDate: "2026-01-20", lastUpdate: "2026-01-20T00:00:00" },
      { item: "CMO MFG End Date", targetDate: "2026-01-23", expectedDate: "2026-01-23", actualDate: "2026-01-23", lastUpdate: "2026-01-23T00:00:00" },
      { item: "PO Due Date", targetDate: "2026-01-21", expectedDate: "2026-01-21", actualDate: "2026-02-15", lastUpdate: "2026-02-15T00:00:00" },
    ],
  },
};

const STATIC_MATERIALS = {
  status: true,
  materialAndConsumptionList: [
    { unitProcedure: "B", operation: "4", phase: "2", materialDescription: "Mannitol", suppliedByAmgen: "Yes", sponsorMaterialCode: "-", cmoMaterialCode: "48719-2", cmoBatchNumber: "MBAT-001", targetQuantity: 100, actualQuantity: 95, uom: "KG", quantityVariance: "0.05" },
    { unitProcedure: "C", operation: "5", phase: "1", materialDescription: "Cysteine Hydrochloride Monohydrate", suppliedByAmgen: "Yes", sponsorMaterialCode: "-", cmoMaterialCode: "46321-2", cmoBatchNumber: "MBAT-002", targetQuantity: "1,250", actualQuantity: "1,250", uom: "KG", quantityVariance: "0.00" },
    { unitProcedure: "D", operation: "2", phase: "3", materialDescription: "Disodium Hydrogen Phosphate", suppliedByAmgen: "Yes", sponsorMaterialCode: "-", cmoMaterialCode: "41789-2", cmoBatchNumber: "MBAT-003", targetQuantity: 0.8, actualQuantity: 0.75, uom: "KG", quantityVariance: "0.06" },
    { unitProcedure: "E", operation: "1", phase: "1", materialDescription: "Glycine", suppliedByAmgen: "Yes", sponsorMaterialCode: "-", cmoMaterialCode: "40562-2", cmoBatchNumber: "MBAT-004", targetQuantity: 0.6, actualQuantity: 0.6, uom: "KG", quantityVariance: "0.00" },
    { unitProcedure: "F", operation: "3", phase: "2", materialDescription: "Polysorbate 80", suppliedByAmgen: "Yes", sponsorMaterialCode: "-", cmoMaterialCode: "47890-2", cmoBatchNumber: "MBAT-005", targetQuantity: 0.5, actualQuantity: 0.48, uom: "KG", quantityVariance: "0.04" },
    { unitProcedure: "G", operation: "2", phase: "1", materialDescription: "Sodium Hydroxide", suppliedByAmgen: "Yes", sponsorMaterialCode: "-", cmoMaterialCode: "43210-2", cmoBatchNumber: "MBAT-006", targetQuantity: 2.5, actualQuantity: 2.5, uom: "KG", quantityVariance: "0.00" },
    { unitProcedure: "H", operation: "4", phase: "3", materialDescription: "WFI (Water for Injection)", suppliedByAmgen: "Yes", sponsorMaterialCode: "WFI-AMG-001", cmoMaterialCode: "WFI-001", cmoBatchNumber: "MBAT-007", targetQuantity: 5000, actualQuantity: 4950, uom: "L", quantityVariance: "0.01" },
  ],
};

const STATIC_IN_PROCESS_TESTS = {
  status: true,
  inProcessTestList: [
    { unitProcedure: "B", operationNumber: "4", phase: "2", operationDescription: "pH Measurement", methodId: "MTH-PH-001", sampleDescription: "In-process pH sample", qcReceiptDate: "2026-01-23", sampleId: "INW-001", arNumber: "AR-2026-001", specificationLimit: "6.0-8.0", resultValue: "7.2", uom: "pH", result: "Pass", cqas: "Yes" },
    { unitProcedure: "C", operationNumber: "5", phase: "1", operationDescription: "Protein Concentration", methodId: "MTH-UV-001", sampleDescription: "Protein conc sample", qcReceiptDate: "2026-01-21", sampleId: "INW-002", arNumber: "AR-2026-002", specificationLimit: "45-55 mg/mL", resultValue: "50.2", uom: "mg/mL", result: "Pass", cqas: "Yes" },
    { unitProcedure: "D", operationNumber: "2", phase: "3", operationDescription: "Turbidity Check", methodId: "MTH-TRB-001", sampleDescription: "Turbidity sample", qcReceiptDate: "2026-01-20", sampleId: "INW-003", arNumber: "AR-2026-003", specificationLimit: "NMT 5 NTU", resultValue: "2.1", uom: "NTU", result: "Pass", cqas: "No" },
    { unitProcedure: "E", operationNumber: "1", phase: "1", operationDescription: "Osmolality Test", methodId: "MTH-OSM-001", sampleDescription: "Osmolality sample", qcReceiptDate: "2026-01-20", sampleId: "INW-004", arNumber: "AR-2026-004", specificationLimit: "280-320 mOsm/kg", resultValue: "295", uom: "mOsm/kg", result: "Pass", cqas: "Yes" },
  ],
};

const STATIC_PRODUCT_RELEASE = {
  status: true,
  productReleaseTestList: [
    { unitProcedure: "E", operation: "FINAL", phase: "1", methodId: "MTH-HPLC-001", sampleDescription: "Final product composite", qcReceiptDate: "2026-01-25", sampleId: "INW-010", arNumber: "AR-2026-010", specificationLimit: "95.0-105.0%", resultValue: "99.8", uom: "%", result: "Pass", cqas: "Yes" },
    { unitProcedure: "E", operation: "FINAL", phase: "2", methodId: "MTH-SEC-001", sampleDescription: "Final product SEC", qcReceiptDate: "2026-01-25", sampleId: "INW-011", arNumber: "AR-2026-011", specificationLimit: "NMT 1.0%", resultValue: "0.3", uom: "%", result: "Pass", cqas: "Yes" },
    { unitProcedure: "E", operation: "FINAL", phase: "3", methodId: "MTH-LAL-001", sampleDescription: "Final product LAL", qcReceiptDate: "2026-01-24", sampleId: "INW-012", arNumber: "AR-2026-012", specificationLimit: "NMT 5 EU/mL", resultValue: "0.8", uom: "EU/mL", result: "Pass", cqas: "Yes" },
    { unitProcedure: "E", operation: "FINAL", phase: "4", methodId: "MTH-STER-001", sampleDescription: "Sterility test", qcReceiptDate: "2026-01-24", sampleId: "INW-013", arNumber: "AR-2026-013", specificationLimit: "No growth 14 days", resultValue: "No growth", uom: "-", result: "Pass", cqas: "Yes" },
  ],
};

const STATIC_DEVIATIONS = {
  status: true,
  deviationList: [
    { unitProcedure: "B", operation: "4", phase: "2", deviationNumber: "DEV-2026-001", reportingDate: "2026-01-23", initialDescription: "Brief temp excursion during formulation", assessmentReport: { name: "Assessment Report DEV-001.pdf", timestamp: "2026-02-04T10:00:00" }, finalReport: { name: "Final Report DEV-001.pdf", timestamp: "2026-02-10T15:00:00" }, correctiveAction: { text: "Adjusted HVAC settings", caStatus: "Closed" }, cmoCAStatus: "Closed", preventiveAction: { text: "Enhanced monitoring alerts", paStatus: "Closed" }, cmoPAStatus: "Closed", deviationStatus: "Closed", deviationCategory: "Critical", deviationType: "Process", informedSponsor: "Yes", sponsorDeviationStatus: "Approved", sponsorDeviationId: "SDEV-001" },
    { unitProcedure: "C", operation: "5", phase: "1", deviationNumber: "DEV-2026-002", reportingDate: "2026-01-22", initialDescription: "Single pH reading out of range", assessmentReport: { name: "Assessment Report DEV-002.pdf", timestamp: "2026-02-06T09:00:00" }, finalReport: { name: "", timestamp: "" }, correctiveAction: { text: "Retesting performed", caStatus: "Open" }, cmoCAStatus: "Open", preventiveAction: { text: "Calibration schedule updated", paStatus: "Pending" }, cmoPAStatus: "Pending", deviationStatus: "Under Review", deviationCategory: "Major", deviationType: "Testing", informedSponsor: "Yes", sponsorDeviationStatus: "Under Review", sponsorDeviationId: "SDEV-002" },
    { unitProcedure: "D", operation: "2", phase: "3", deviationNumber: "DEV-2026-003", reportingDate: "2026-01-22", initialDescription: "Operator signature missing from page 45", assessmentReport: { name: "", timestamp: "" }, finalReport: { name: "Final Report DEV-003.pdf", timestamp: "2026-02-09T11:00:00" }, correctiveAction: { text: "Signature obtained", caStatus: "Closed" }, cmoCAStatus: "Closed", preventiveAction: { text: "BMR review checklist added", paStatus: "Closed" }, cmoPAStatus: "Closed", deviationStatus: "Closed", deviationCategory: "Minor", deviationType: "Documentation", informedSponsor: "No", sponsorDeviationStatus: "N/A", sponsorDeviationId: "N/A" },
    { unitProcedure: "E", operation: "1", phase: "1", deviationNumber: "DEV-2026-004", reportingDate: "2026-01-21", initialDescription: "Peristaltic pump stopped mid-operation", assessmentReport: { name: "Assessment Report DEV-004.pdf", timestamp: "2026-02-10T08:00:00" }, finalReport: { name: "Final Report DEV-004.pdf", timestamp: "2026-02-14T16:00:00" }, correctiveAction: { text: "Pump replaced and batch resumed", caStatus: "Closed" }, cmoCAStatus: "Closed", preventiveAction: { text: "PM schedule updated", paStatus: "Closed" }, cmoPAStatus: "Closed", deviationStatus: "Closed", deviationCategory: "Major", deviationType: "Equipment", informedSponsor: "Yes", sponsorDeviationStatus: "Approved", sponsorDeviationId: "SDEV-004" },
  ],
};

const STATIC_CHANGE_CONTROLS = {
  status: true,
  changeControlList: [
    { ccType: "Change Control", sponsorCCNumber: "SCC-001", sponsorCCStatus: "Acknowledged", cmoCCNumber: "CC-2026-001", initialDocNumber: "PROC-V1", finalDocNumber: "PROC-V2", changeFrom: "Mixing speed 200 RPM", changeTo: "Mixing speed 250 RPM", reasonsForChange: "Improve homogeneity", ccClosureReport: { name: "CC Closure Report 001.pdf" }, cmoCCStatus: "Approved" },
    { ccType: "Change Control", sponsorCCNumber: "SCC-002", sponsorCCStatus: "Under Review", cmoCCNumber: "CC-2026-002", initialDocNumber: "MTH-V1", finalDocNumber: "MTH-V2", changeFrom: "Column temp 25C", changeTo: "Column temp 30C", reasonsForChange: "Better peak resolution", ccClosureReport: { name: "" }, cmoCCStatus: "Approved" },
    { ccType: "Change Control", sponsorCCNumber: "SCC-003", sponsorCCStatus: "Pending", cmoCCNumber: "CC-2026-003", initialDocNumber: "PKG-V1", finalDocNumber: "PKG-V2", changeFrom: "Supplier A vials", changeTo: "Supplier B vials", reasonsForChange: "Supplier A discontinuing", ccClosureReport: { name: "" }, cmoCCStatus: "Under Review" },
    { ccType: "Planned CC", sponsorCCNumber: "PSCC-001", sponsorCCStatus: "Planned", cmoCCNumber: "PCC-2026-001", initialDocNumber: "PROC-FILL-V1", finalDocNumber: "PROC-FILL-V2", changeFrom: "Manual fill", changeTo: "Automated fill", reasonsForChange: "Scale-up preparation", ccClosureReport: { name: "" }, cmoCCStatus: "Planned" },
    { ccType: "Planned CC", sponsorCCNumber: "PSCC-002", sponsorCCStatus: "Planned", cmoCCNumber: "PCC-2026-002", initialDocNumber: "PROC-CLEAN-V3", finalDocNumber: "PROC-CLEAN-V4", changeFrom: "Manual CIP", changeTo: "Automated CIP", reasonsForChange: "Consistency improvement", ccClosureReport: { name: "" }, cmoCCStatus: "Planned" },
  ],
};

const STATIC_CYCLE_TIME = {
  status: true,
  cycleTimeList: [
    { rowHeader: "B\n4", unitProcedure: "B", operation: "4", phase: "2", procedureName: "Formulation", actualStartTime: { date: "2026-01-20", time: "10:30" }, actualEndTime: { date: "2026-01-22", time: "08:30" }, plannedCycleTime: "48 hrs", actualCycleTime: "52 hrs" },
    { rowHeader: "C\n5", unitProcedure: "C", operation: "5", phase: "1", procedureName: "Filling", actualStartTime: { date: "2026-01-22", time: "08:30" }, actualEndTime: { date: "2026-01-22", time: "15:30" }, plannedCycleTime: "60 hrs", actualCycleTime: "58 hrs" },
  ],
};

const STATIC_EQUIPMENT = {
  status: true,
  equipmentList: [
    { equipmentId: "EQ-001", location: "Building A - Room 101", equipmentType: "Reactor", description: "Stainless Steel Reactor 500L", reservationStartDate: "2026-01-19", reservationEndDate: "2026-01-23", reservationId: "RES-001", reservationTimestamp: { date: "2026-01-03", time: "15:04" } },
    { equipmentId: "EQ-002", location: "Building A - Room 102", equipmentType: "Mixer", description: "High Shear Mixer", reservationStartDate: "2026-01-19", reservationEndDate: "2026-01-23", reservationId: "RES-002", reservationTimestamp: { date: "2026-01-03", time: "15:04" } },
    { equipmentId: "EQ-003", location: "Building B - Room 201", equipmentType: "Filler", description: "Automated Syringe Filler", reservationStartDate: "2026-01-19", reservationEndDate: "2026-01-23", reservationId: "RES-003", reservationTimestamp: { date: "2026-01-03", time: "15:04" } },
    { equipmentId: "EQ-004", location: "Building B - Room 202", equipmentType: "Lyophilizer", description: "Freeze Dryer Unit 1", reservationStartDate: "2026-01-19", reservationEndDate: "2026-01-23", reservationId: "RES-004", reservationTimestamp: { date: "2026-01-03", time: "15:04" } },
    { equipmentId: "EQ-005", location: "Building C - Room 301", equipmentType: "Inspection", description: "Automated Visual Inspection", reservationStartDate: "2026-01-19", reservationEndDate: "2026-01-23", reservationId: "RES-005", reservationTimestamp: { date: "2026-01-03", time: "15:04" } },
  ],
};

const STATIC_YIELD = {
  status: true,
  yieldList: [
    { plannedProductQuantity: 50000, actualProductQuantity: 48500, uom: "units", molarYield: "97.0%", batchManufacturingDate: "2026-01-20", expiryDate: "2028-01-19", storageCondition: "2-8C", storageLocation: "Warehouse A - Cold Room" },
  ],
};

const STATIC_SHIPMENT = {
  status: true,
  shipmentList: [
    { item: "Primary Shipment", plannedShipmentDate: "2026-01-22", actualShipmentDate: "2026-01-22", expectedDeliveryDate: "2026-01-23", actualDeliveryDate: "2026-01-23" },
    { item: "Secondary Shipment", plannedShipmentDate: "2026-02-02", actualShipmentDate: "2026-02-02", expectedDeliveryDate: "2026-02-03", actualDeliveryDate: "2026-02-03" },
  ],
};

const STATIC_DOCUMENTS = {
  status: true,
  documentList: [
    { collabrixDocumentID: "DOC-001", documentName: "Deviation Report DEV-001", documentCategory: "Deviations", fileName: "Deviation_Report_DEV-001.pdf", uploadDate: "12-MAR-2026" },
    { collabrixDocumentID: "DOC-002", documentName: "Investigation Report DEV-001", documentCategory: "Deviations", fileName: "Investigation_Report_DEV-001.pdf", uploadDate: "13-MAR-2026" },
    { collabrixDocumentID: "DOC-003", documentName: "CC Closure Report CC-001", documentCategory: "Change Controls", fileName: "CC_Closure_Report_001.pdf", uploadDate: "13-MAR-2026" },
  ],
};

const STATIC_TAB_MAP = {
  "Planning": STATIC_PLANNING,
  "Materials & Consumption": STATIC_MATERIALS,
  "In-Process Tests": STATIC_IN_PROCESS_TESTS,
  "Product Release Tests": STATIC_PRODUCT_RELEASE,
  "Deviations": STATIC_DEVIATIONS,
  "CC": STATIC_CHANGE_CONTROLS,
  "Cycle Time": STATIC_CYCLE_TIME,
  "Equipment": STATIC_EQUIPMENT,
  "Yield": STATIC_YIELD,
  "Shipment": STATIC_SHIPMENT,
  "Documents": STATIC_DOCUMENTS,
};

/**
 * Fetch Tab Configuration
 * GET /fetchTabConfiguration/{viewType}/{collabrixCampaignID}
 * 
 * @param {string|number} viewType - 'systemView' or 'overallView' or 1 or 2
 * @param {string} collabrixCampaignID - Campaign ID
 * @returns {Promise} Response with tabConfigurationList
 */
export const fetchTabConfigurationAPI = async (viewType, collabrixCampaignID) => {
  // Static tab configuration matching the screenshot
  return {
    status: true,
    data: {
      // Viral Vector demo: Cycle Time and Shipment tabs removed
      // per "Design Changes for Viral Vector Demo" (Manufacturing Tab Changes).
      // Planning tab restored per request.
      tabConfigurationList: [
        { tabName: 'Planning' },
        { tabName: 'MFG Status' },
        { tabName: 'Materials & Consumption' },
        { tabName: 'In-Process Tests' },
        { tabName: 'Product Release Tests' },
        { tabName: 'Deviations' },
        { tabName: 'CC' },
        { tabName: 'Equipment' },
        { tabName: 'Yield' },
        { tabName: 'Documents' },
        { tabName: 'Comments' },
      ],
    },
  };
};

/**
 * Fetch Materials & Consumption
 * POST /fetchMaterialAndConsumption
 */
export const fetchMaterialAndConsumptionAPI = async (payload) => {
  return await callGenericTabAPI('fetchMaterialAndConsumption', payload, 'Materials & Consumption');
};

/**
 * Fetch CPP Details
 * POST /fetchCPPDetails
 */
export const fetchCPPDetailsAPI = async (payload) => {
  return await callGenericTabAPI('fetchCPPDetails', payload);
};

/**
 * Fetch In-Process Tests
 * POST /fetchInProcessTest
 */
export const fetchInProcessTestAPI = async (payload) => {
  return await callGenericTabAPI('fetchInProcessTest', payload, 'In-Process Tests');
};

/**
 * Fetch Product Release Tests
 * POST /fetchProductReleaseTest
 */
export const fetchProductReleaseTestAPI = async (payload) => {
  return await callGenericTabAPI('fetchProductReleaseTest', payload, 'Product Release Tests');
};

/**
 * Fetch Deviations
 * POST /fetchDeviations
 */
export const fetchDeviationsAPI = async (payload) => {
  return await callGenericTabAPI('fetchDeviations', payload, 'Deviations');
};

/**
 * Generate a Quality Event in the Sponsor QMS (Veeva Vault) from a deviation.
 * Sponsor-side action from the Deviations tab "Generate Deviation" flow.
 *
 * Simulates the QMS round-trip (network latency + generated sponsor QE id) so
 * the Create Quality Event screen behaves like a real API call. When the
 * backend endpoint is ready, flip USE_STATIC_DATA to false and it will POST to
 * /generateSponsorQualityEvent instead.
 */
export const generateSponsorQualityEvent = async (payload) => {
  const bmsDeviationId = payload?.bmsDeviationId || 'QE-2026-0005';

  if (USE_STATIC_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return {
      status: true,
      sponsorDeviationId: `SP-${bmsDeviationId}`,
      sponsorDeviationStatus: 'New',
      message: 'Fields sent to Sponsor QMS for QE creation.',
    };
  }

  const apiBaseUrl = getApiBaseUrl();
  try {
    // Give the UI a visible "calling API" moment even when the real endpoint is fast.
    await new Promise((resolve) => setTimeout(resolve, 1200));
    if (!apiBaseUrl) throw new Error('API base URL not available');
    const response = await axios.post(
      `${apiBaseUrl}/generateSponsorQualityEvent`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('generateSponsorQualityEvent failed, using simulated response:', error);
    // Standalone fallback so the demo flow always completes successfully.
    return {
      status: true,
      sponsorDeviationId: `SP-${bmsDeviationId}`,
      sponsorDeviationStatus: 'New',
      message: 'Fields sent to Sponsor QMS for QE creation.',
    };
  }
};

/**
 * Fetch Change Controls
 * POST /fetchChangeControls
 */
export const fetchChangeControlsAPI = async (payload) => {
  return await callGenericTabAPI('fetchChangeControls', payload, 'CC');
};

/**
 * Fetch Cycle Time
 * POST /fetchCycleTime
 */
export const fetchCycleTimeAPI = async (payload) => {
  return await callGenericTabAPI('fetchCycleTime', payload, 'Cycle Time');
};

/**
 * Fetch Equipment
 * POST /fetchEquipment
 */
export const fetchEquipmentAPI = async (payload) => {
  return await callGenericTabAPI('fetchEquipment', payload, 'Equipment');
};

/**
 * Fetch Yield
 * POST /fetchYield
 */
export const fetchYieldAPI = async (payload) => {
  return await callGenericTabAPI('fetchYield', payload, 'Yield');
};

/**
 * Fetch Manufacturing Planning — NO-OP.
 * Planning is driven entirely by the per-batch "Planning" Excel sheet
 * (PlanningTab -> selectTabData(PLANNING_DATA, ...)); the backend is intentionally
 * NOT queried. Returns an empty payload so the tab loads immediately and the Excel
 * data is the sole source. Kept in the tab->fetcher map for consistency.
 */
export const fetchMfgPlanningAPI = async () => {
  return { status: true, planningData: { headerFields: [], milestones: [] } };
};

/**
 * Fetch Manufacturing Shipment
 * POST /fetchMfgShipment
 */
export const fetchMfgShipmentAPI = async (payload) => {
  if (USE_STATIC_DATA) return STATIC_SHIPMENT;
  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) return { status: true, shipmentList: [] };
  try {
    const response = await axios.post(`${apiBaseUrl}/fetchMfgShipment`, payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching shipment data:', error);
    return { status: true, shipmentList: [] };
  }
};

/**
 * Fetch Batch Documents
 * POST /fetchBatchDocuments
 */
export const fetchBatchDocumentsAPI = async () => {
  // Documents tab is always static — no real API call
  return STATIC_DOCUMENTS;
};

/**
 * Add Batch Document
 * POST /addBatchDocument
 */
export const addBatchDocumentAPI = async (payload) => {
  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) throw new Error('API base URL not available');
  try {
    const response = await axios.post(`${apiBaseUrl}/addBatchDocument`, payload);
    return response.data;
  } catch (error) {
    console.error('Error adding batch document:', error);
    throw error;
  }
};

/**
 * Add Planning Milestone
 * POST /addPlanningMilestone
 */
export const addPlanningMilestoneAPI = async (payload) => {
  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) throw new Error('API base URL not available');
  try {
    const response = await axios.post(`${apiBaseUrl}/addPlanningMilestone`, payload);
    return response.data;
  } catch (error) {
    console.error('Error adding planning milestone:', error);
    throw error;
  }
};

/**
 * Add Shipment Tracking
 * POST /addShipmentTracking
 */
export const addShipmentTrackingAPI = async (payload) => {
  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) throw new Error('API base URL not available');
  try {
    const response = await axios.post(`${apiBaseUrl}/addShipmentTracking`, payload);
    return response.data;
  } catch (error) {
    console.error('Error adding shipment tracking:', error);
    throw error;
  }
};

// ─── Static Documents (always shown as-is, no real API call) ──────────────────
// const STATIC_DOCUMENTS = {
//   status: true,
//   documentList: [
//     { collabrixDocumentID: 'DOC-001', documentName: 'Deviation Report DEV-001', documentCategory: 'Deviations', fileName: 'Deviation_Report_DEV-001.pdf', uploadDate: '12-MAR-2026' },
//     { collabrixDocumentID: 'DOC-002', documentName: 'Investigation Report DEV-001', documentCategory: 'Deviations', fileName: 'Investigation_Report_DEV-001.pdf', uploadDate: '13-MAR-2026' },
//     { collabrixDocumentID: 'DOC-003', documentName: 'CC Closure Report CC-001', documentCategory: 'Change Controls', fileName: 'CC_Closure_Report_001.pdf', uploadDate: '13-MAR-2026' },
//   ],
// };

/**
 * Fetch Batch Documents
 * Documents tab is always static — no real API call.
 */
// export const fetchBatchDocumentsAPI = async () => {
//   return STATIC_DOCUMENTS;
// };

/**
 * Convert tab name to API endpoint name
 * Examples: "Material & Consumption" -> "fetchMaterialAndConsumption"
 *           "Batch Records" -> "fetchBatchRecords"
 *           "Quality Events" -> "fetchQualityEvents"
 */
const tabNameToApiEndpoint = (tabName) => {
  // Handle special cases first
  const specialCases = {
    "Material & Consumption": "fetchMaterialAndConsumption",
    "Materials & Consumption": "fetchMaterialAndConsumption",
    "CPP Details": "fetchCPPDetails",
    "CPPs": "fetchCPPDetails",
    "In Process Test": "fetchInProcessTest",
    "In-Process Tests": "fetchInProcessTest",
    "Product Release Test": "fetchProductReleaseTest",
    "Product Release Tests": "fetchProductReleaseTest",
    "Deviations": "fetchDeviations",
    "Change Controls": "fetchChangeControls",
    "CC": "fetchChangeControls",
    "Cycle Time": "fetchCycleTime",
    "Equipment": "fetchEquipment",
    "Yield": "fetchYield",
  };
  
  if (specialCases[tabName]) {
    return specialCases[tabName];
  }
  
  // Generic conversion: "Batch Records" -> "fetchBatchRecords"
  // Remove special characters, convert to camelCase, prefix with "fetch"
  const cleaned = tabName
    .replace(/[&]/g, '') // Remove &
    .replace(/\s+/g, ' ') // Normalize spaces
    .trim();
  
  const words = cleaned.split(' ');
  const camelCase = words.map((word, index) => {
    if (index === 0) {
      return word.charAt(0).toLowerCase() + word.slice(1);
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join('');
  
  return `fetch${camelCase.charAt(0).toUpperCase()}${camelCase.slice(1)}`;
};

/**
 * Generic API function that dynamically calls any tab API
 */
const callGenericTabAPI = async (endpointName, payload, tabName) => {
  // Return static data if enabled and available
  if (USE_STATIC_DATA && tabName && STATIC_TAB_MAP[tabName]) {
    console.log(`[Static] Returning static data for tab: ${tabName}`);
    return STATIC_TAB_MAP[tabName];
  }

  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) {
    throw new Error("API base URL not available");
  }

  try {
    console.log(`POST API: ${endpointName}`);
    const response = await axios.post(
      `${apiBaseUrl}/${endpointName}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${endpointName}:`, error);
    throw error;
  }
};

/**
 * Filter a static tab response by collabrixBatchID from the payload.
 * Finds the list array in the response object and filters it.
 */
const filterStaticData = (data, payload) => {
  const batchID = payload?.collabrixBatchID;
  if (!batchID) return data;

  // Find the list key (e.g., materialAndConsumptionList, inProcessTestList, ...)
  const listKey = Object.keys(data).find(
    (k) => Array.isArray(data[k])
  );
  if (!listKey) return data;

  const filtered = data[listKey].filter(
    (item) => item.collabrixBatchID === batchID
  );

  console.log(
    `[TabAPI] Filtered ${listKey}: ${data[listKey].length} → ${filtered.length} rows (batchID: ${batchID})`
  );

  return { ...data, [listKey]: filtered };
};

/**
 * Map tab name to API function - Fully dynamic
 * Always calls real API for every tab.
 */
export const getTabAPI = (tabName) => {
  // First check for explicit mappings (for backward compatibility)
  const explicitMap = {
    "Material & Consumption": fetchMaterialAndConsumptionAPI,
    "Materials & Consumption": fetchMaterialAndConsumptionAPI,
    "CPP Details": fetchCPPDetailsAPI,
    "CPPs": fetchCPPDetailsAPI,
    "In Process Test": fetchInProcessTestAPI,
    "In-Process Tests": fetchInProcessTestAPI,
    "Product Release Test": fetchProductReleaseTestAPI,
    "Product Release Tests": fetchProductReleaseTestAPI,
    "Deviations": fetchDeviationsAPI,
    "Change Controls": fetchChangeControlsAPI,
    "CC": fetchChangeControlsAPI,
    "Cycle Time": fetchCycleTimeAPI,
    "Equipment": fetchEquipmentAPI,
    "Yield": fetchYieldAPI,
    "Planning": fetchMfgPlanningAPI,
    "Shipment": fetchMfgShipmentAPI,
    "Documents": fetchBatchDocumentsAPI,
  };
  
  if (explicitMap[tabName]) {
    return explicitMap[tabName];
  }

  // For every tab, create a dynamic API function that calls the real backend
  const endpointName = tabNameToApiEndpoint(tabName);
  console.log(`[TabAPI] Creating dynamic API for tab "${tabName}" -> endpoint: ${endpointName}`);

  return async (payload) => {
    return await callGenericTabAPI(endpointName, payload);
  };
};

/**
 * Get tab names that have static data available (for supplementing API response)
 */
export const getStaticTabNames = () => {
  return Object.keys(staticTabData);
};

/**
 * Map tab name to response data key
 */
export const getTabResponseKey = (tabName) => {
  const responseKeyMap = {
    "Materials & Consumption": "materialAndConsumptionList",
    "CPPs": "cppDetailsList",
    "In-Process Tests": "inProcessTestList",
    "Product Release Tests": "productReleaseTestList",
    "Deviations": "deviationList",
    "Change Controls": "changeControlList",
    "CC": "changeControlList",
    "Cycle Time": "cycleTimeList",
    "Equipment": "equipmentList",
    "Yield": "yieldList",
    "Planning": "planningData",
    "Shipment": "shipmentList",
    "Documents": "documentList",
  };
  
  return responseKeyMap[tabName] || null;
};
